<template>
  <div class="pulse-message" :class="`pulse-message--${severidade}`">
    <i :class="['pi', icone]" />
    <div class="pulse-message__text"><slot /></div>
    <button
      v-if="closable"
      type="button"
      class="pulse-message__close"
      @click="$emit('close')"
    >
      <i class="pi pi-times" />
    </button>
  </div>
</template>

<script>
const ALIASES = { warning: "warn", danger: "error" };
const ICONES = {
  info: "pi-info-circle",
  success: "pi-check-circle",
  warn: "pi-exclamation-triangle",
  error: "pi-times-circle",
};

export default {
  name: "PulseMessage",
  props: {
    severity: { type: String, default: "info" },
    closable: Boolean,
  },
  computed: {
    severidade() {
      const valor = ALIASES[this.severity] || this.severity;
      return ICONES[valor] ? valor : "info";
    },
    icone() {
      return ICONES[this.severidade];
    },
  },
};
</script>
